/**
 * AddDRMProfileCtrl controller
 * Add/edit DRM Profile
 */

import { DRM_PROFILE_TYPES, DRM_ACCOUNT_TYPES, HDCP_TYPES, ROBUSTNESS_TYPES, SECURITY_LEVEL_TYPES, DRM_ACCOUNT_TYPES_LABELS, DRM_PROFILE_TYPES_LABES } from 'app/core/constants'

/**
 * AddDRMProfileCtrl controller
 *
 * @class AddDRMProfileCtrl
 * @memberof mwApp/settings
 * @see mwApp/settings
 *
 * @ngdoc controller
 * @name mwApp/settings.controller:AddDRMProfileCtrl
 */
/* @ngInject */
export default function AddDRMProfileCtrl ($scope, $uibModalInstance, profile, providerType) {
  var vm = this

  $scope.$watch('vm.profile.persistentLicense', (v) => {
    if (!v) {
      vm.profile.rentalDurationSec = 0
      vm.profile.licenseDurationSec = 0
    }
  })

  // -
  setHDCPValues()

  /**
   * DRM Profile
   *
   * @memberof mwApp/settings.controller:AddDRMProfileCtrl
   * @type {models.DRMProfile}
   */
  vm.profile = profile

  vm.requiredCertificate = profile.fpsCertificateFileName

  /**
   * isNew flag
   *
   * @memberof mwApp/settings.controller:AddDRMProfileCtrl
   * @type {Boolean}
   */
  vm.isNew = profile._isNew()

  /**
   * DRM Account provider type
   *
   * @memberof mwApp/settings.controller:AddDRMProfileCtrl
   * @type {String}
   */
  vm.providerType = providerType

  /**
   * DRM Profile drm types
   *
   * @memberof mwApp/settings.controller:AddDRMProfileCtrl
   * @type {{}}
   */
  vm.drm_profile_types = DRM_PROFILE_TYPES

  /**
   * DRM Profile drm keys
   *
   * @memberof mwApp/settings.controller:AddDRMProfileCtrl
   * @type {{}}
   */
  vm.drm_profile_types_keys = Object.keys(DRM_PROFILE_TYPES_LABES)

  /**
   * DRM Profile drm labels of types
   *
   * @memberof mwApp/settings.controller:AddDRMProfileCtrl
   * @type {{}}
   */
  vm.drm_profile_types_labels = DRM_PROFILE_TYPES_LABES

  /**
   * DRM Profile drm types
   *
   * @memberof mwApp/settings.controller:AddDRMProfileCtrl
   * @type {{}}
   */
  vm.drm_account_types = DRM_ACCOUNT_TYPES

  /**
   * DRM Profile drm types labels
   *
   * @memberof mwApp/settings.controller:AddDRMProfileCtrl
   * @type {{}}
   */
  vm.drm_account_types_labels = DRM_ACCOUNT_TYPES_LABELS

  /**
   * DRM Profile hdcp types
   *
   * @memberof mwApp/settings.controller:AddDRMProfileCtrl
   * @type {{}}
   */
  vm.hdcp_types = HDCP_TYPES

  /**
   * DRM Profile Robustness types
   *
   * @memberof mwApp/settings.controller:AddDRMProfileCtrl
   * @type {{}}
   */
  vm.robustness_types = ROBUSTNESS_TYPES

  /**
   * Security Level types
   *
   * @memberof mwApp/settings.controller:AddDRMProfileCtrl
   * @type {{}}
   */
  vm.security_level_types = SECURITY_LEVEL_TYPES

  /**
   * Security Level values
   *
   * @memberof mwApp/settings.controller:AddDRMProfileCtrl
   * @type {String[]}
   */
  vm.securityLevelValues = Object.keys(SECURITY_LEVEL_TYPES).splice(0, 2)

  /**
   * Change DRM type
   *
   * @memberof mwApp/settings.controller:AddDRMProfileCtrl
   * @function
   */
  vm.changeDrmType = () => {
    setHDCPValues()
  }

  /**
   * Upload certificate
   *
   * @memberOf mwApp/settings.controller:AddDRMProfileCtrl
   * @function
   */
  vm.uploadCertificate = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new window.FileReader()
      reader.onload = function () {
        vm.profile.fpsCertificateFileName = file.name
        vm.profile.fpsCertificate = reader.result
          .replace('data:', '')
          .replace(/^.+,/, '')
        resolve(file)
        vm.form.$setDirty()
      }

      reader.onerror = function (e) {
        reader.abort()
        reject(e)
      }
      reader.readAsDataURL(file)
    })
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/settings.controller:AddDRMProfileCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }

  /**
   * Create/update DRM Profile
   *
   * @memberof mwApp/settings.controller:AddDRMProfileCtrl
   */
  vm.save = function () {
    vm.setDisable()

    profile._save()
      .then(() => {
        // reload catchup after create/update
        profile._update()
          .finally(
            () => {
              $uibModalInstance.close(profile)
              vm.unsetDisable()
            }
          )
      }).finally(vm.unsetDisable)
  }

  /**
   * Change HDCP values by drm type
   */
  function setHDCPValues () {
    vm.hdcpValues = providerType !== DRM_ACCOUNT_TYPES.EZDRM
      ? ['NO_HDCP', 'HDCP_V1_4', 'HDCP_V2_2']
      : ['NO_HDCP', 'HDCP_V1', 'HDCP_V2', 'HDCP_V2_1', 'HDCP_V2_2', 'HDCP_NO_DIGITAL_OUTPUT']
  }

  /**
   *  Filter for profile types
   * @returns {Function}
   */
  $scope.filterProfileTypes = function () {
    return function (type) {
      if (vm.providerType === DRM_ACCOUNT_TYPES.IRDETO) {
        return type !== DRM_PROFILE_TYPES.MARLIN
      }
      return true
    }
  }
}
